import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop — premium route-change scroll behavior.
 *
 * - Smooth scroll on every pushed route change.
 * - Honors prefers-reduced-motion (uses 'auto' instead of 'smooth').
 * - Skips the very first mount to avoid scroll-jacking deep links / SSR hydration.
 * - Skips when navigating to a hash anchor (e.g. /faq#getting-started).
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const firstMountRef = useRef(true);

  useEffect(() => {
    if (firstMountRef.current) {
      firstMountRef.current = false;
      return;
    }
    if (hash) {
      // Let the browser anchor scroll handle it.
      return;
    }
    const reduced =
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: reduced ? 'auto' : 'smooth',
      });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
